module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[97]96.0b526a7.woff2";